import * as React from "react";
import { Fragment } from "react";
import { BuildDefinitionIcon, ClockIcon, BullseyeIcon, DesignIcon } from "@fluentui/react-icons-mdl2";
import { useLanguage } from "../../common/i18n/i18n";

const OrganizationTutorial = () => {
  const { labels } = useLanguage();

  return (
    <Fragment>
      <div className="blink-tutorial-main">
        <div className="blink-tutorial-item">
          <div className="blink-tutorial-title">
            <div className="blink-tutorial-h1">
              <BuildDefinitionIcon />
              <div>{labels.LABELS_I18N.organizationTutorial.automatizationLabel}</div>
            </div>
          </div>
          <div className="blink-tutorial-text">{labels.LABELS_I18N.organizationTutorial.automatizationText}</div>
        </div>
        <div className="blink-tutorial-item">
          <div className="blink-tutorial-title">
            <div className="blink-tutorial-h1">
              <ClockIcon />
              <div>{labels.LABELS_I18N.organizationTutorial.timeLabel}</div>
            </div>
          </div>
          <div className="blink-tutorial-text">{labels.LABELS_I18N.organizationTutorial.timeText}</div>
        </div>
        <div className="blink-tutorial-item">
          <div className="blink-tutorial-title">
            <div className="blink-tutorial-h1">
              <BullseyeIcon />
              <div>{labels.LABELS_I18N.organizationTutorial.qualityLabel}</div>
            </div>
          </div>
          <div className="blink-tutorial-text">
            {labels.LABELS_I18N.organizationTutorial.qualityText}
            <b>BlinKRS</b>
            {labels.LABELS_I18N.organizationTutorial.qualityText2}
          </div>
        </div>
        <div className="blink-tutorial-item">
          <div className="blink-tutorial-title">
            <div className="blink-tutorial-h1">
              <DesignIcon />
              <div>{labels.LABELS_I18N.organizationTutorial.easeOfUseLabel}</div>
            </div>
          </div>
          <div className="blink-tutorial-text">
            <b>BlinKRS</b> {labels.LABELS_I18N.organizationTutorial.easeOfUseText}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default OrganizationTutorial;
